import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

const Header = dynamic(() => import('./header'));

const WPAdminHeader = ({
  isEnabled,
  editLink,
}: {
  isEnabled: boolean;
  editLink: null | string;
}) => {
  const [isLoggedin, setLoggedIn] = useState(false);

  useEffect(() => {
    if (!isEnabled && !isLoggedin) {
      (async () => {
        try {
          const res = await fetch('/api/allow-controls');
          if (res.ok && res?.status === 200) {
            setLoggedIn(true);
          }
        } catch (_) {
          /* silence is golden */
        }
      })();
    }
  }, [isEnabled, isLoggedin]);

  if (!isEnabled && typeof document === 'undefined') {
    return null;
  }
  if (isEnabled) {
    return <Header editLink={editLink} isEnabled />;
  }

  if (isLoggedin) {
    return <Header editLink={editLink} />;
  }
  return null;
};

export default WPAdminHeader;
